"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var constants_1 = require("../../../../../../constants/constants");
var main_1 = require("../../../../../../reducers/slices/main");
var react_router_dom_1 = require("react-router-dom");
var create_shipment_1 = require("../../../../../../api/calls/integration/bobgroup/create_shipment");
var moment_1 = __importDefault(require("moment"));
var get_order_thunk_1 = require("../../../../../../reducers/slices/orders/thunks/get_order_thunk");
var RateViewComponent = function (props) {
    var rates = props.rates, parcel = props.parcel;
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var selectedOrder = (0, react_redux_1.useSelector)(function (state) { return state.orderState; }).selectedOrder;
    var _a = (0, react_1.useState)(0), selectedID = _a[0], setSelectedID = _a[1];
    var getDates = function (parcel) {
        var _a, _b, _c, _d, _e, _f;
        var pickUpDateTime = null;
        var deliveryDateTime = null;
        if ((_a = parcel === null || parcel === void 0 ? void 0 : parcel.collection_date) === null || _a === void 0 ? void 0 : _a.specified)
            pickUpDateTime = "".concat(parcel === null || parcel === void 0 ? void 0 : parcel.collection_date.specified, " ").concat((_b = parcel === null || parcel === void 0 ? void 0 : parcel.collection_time) === null || _b === void 0 ? void 0 : _b.specified);
        if ((_c = parcel === null || parcel === void 0 ? void 0 : parcel.collection_date) === null || _c === void 0 ? void 0 : _c.actual)
            pickUpDateTime = "".concat(parcel === null || parcel === void 0 ? void 0 : parcel.collection_date.actual, " ").concat((_d = parcel === null || parcel === void 0 ? void 0 : parcel.collection_time) === null || _d === void 0 ? void 0 : _d.actual);
        if (pickUpDateTime && ((_e = parcel === null || parcel === void 0 ? void 0 : parcel.estimated_travel_time) === null || _e === void 0 ? void 0 : _e.value)) {
            deliveryDateTime = (0, moment_1.default)(pickUpDateTime).add((_f = parcel === null || parcel === void 0 ? void 0 : parcel.estimated_travel_time) === null || _f === void 0 ? void 0 : _f.value, "seconds");
        }
        return {
            pickUpDateTime: pickUpDateTime !== null && pickUpDateTime !== void 0 ? pickUpDateTime : parcel.updatedAt,
            deliveryDateTime: deliveryDateTime !== null && deliveryDateTime !== void 0 ? deliveryDateTime : parcel.updatedAt,
        };
    };
    var handleResponse = function (response) {
        setSelectedID(0);
        if (response.success) {
            dispatch((0, main_1.setContentModal)(null));
            dispatch((0, main_1.setContentModal)({ title: "Success", content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
            dispatch((0, get_order_thunk_1.get_order_thunk)({ _id: selectedOrder._id, showLoader: false }));
        }
        else
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: response.message }) }));
    };
    var _onSubmit = function (rate) { return __awaiter(void 0, void 0, void 0, function () {
        var _getDates, response;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    setSelectedID((_a = rate === null || rate === void 0 ? void 0 : rate.service_level) === null || _a === void 0 ? void 0 : _a.id);
                    _getDates = getDates(parcel);
                    return [4 /*yield*/, (0, create_shipment_1.create_shipment)({
                            parcel_id: parcel._id,
                            data: {
                                collection_address: {
                                    type: "business",
                                    company: (_b = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _b === void 0 ? void 0 : _b.display_name,
                                    street_address: (_d = (_c = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.full_address,
                                    lat: Number((_f = (_e = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _e === void 0 ? void 0 : _e.address) === null || _f === void 0 ? void 0 : _f.latitude),
                                    lng: Number((_h = (_g = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _g === void 0 ? void 0 : _g.address) === null || _h === void 0 ? void 0 : _h.longitude),
                                },
                                delivery_address: {
                                    type: "residential",
                                    company: "",
                                    street_address: (_j = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _j === void 0 ? void 0 : _j.full_address,
                                    lat: Number((_k = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _k === void 0 ? void 0 : _k.lat),
                                    lng: Number((_l = parcel === null || parcel === void 0 ? void 0 : parcel.delivery_address) === null || _l === void 0 ? void 0 : _l.lon),
                                },
                                collection_contact: {
                                    name: (_m = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _m === void 0 ? void 0 : _m.display_name,
                                    mobile_number: (_o = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _o === void 0 ? void 0 : _o.contact_number,
                                    email: (_p = parcel === null || parcel === void 0 ? void 0 : parcel.branch) === null || _p === void 0 ? void 0 : _p.email,
                                },
                                delivery_contact: {
                                    name: (_q = parcel === null || parcel === void 0 ? void 0 : parcel.sender) === null || _q === void 0 ? void 0 : _q.full_name,
                                    mobile_number: (_r = parcel === null || parcel === void 0 ? void 0 : parcel.sender) === null || _r === void 0 ? void 0 : _r.email,
                                    email: (_s = parcel === null || parcel === void 0 ? void 0 : parcel.sender) === null || _s === void 0 ? void 0 : _s.email,
                                },
                                parcels: (parcel === null || parcel === void 0 ? void 0 : parcel.product_dimensions)
                                    ? parcel === null || parcel === void 0 ? void 0 : parcel.product_dimensions.map(function (x) {
                                        return {
                                            submitted_length_cm: Number(x.length),
                                            submitted_width_cm: Number(x.width),
                                            submitted_height_cm: Number(x.height),
                                            submitted_weight_kg: Number(x.weight),
                                        };
                                    })
                                    : [],
                                opt_in_rates: [],
                                opt_in_time_based_rates: [],
                                special_instructions_collection: "",
                                special_instructions_delivery: "",
                                collection_min_date: _getDates.pickUpDateTime.toString(),
                                delivery_min_date: _getDates.deliveryDateTime.toString(),
                                custom_tracking_reference: "",
                                customer_reference: parcel === null || parcel === void 0 ? void 0 : parcel.code,
                                service_level_code: (_t = rate === null || rate === void 0 ? void 0 : rate.service_level) === null || _t === void 0 ? void 0 : _t.code,
                                mute_notifications: false,
                            },
                        })];
                case 1:
                    response = _u.sent();
                    handleResponse(response);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "grid grid-cols-".concat(rates === null || rates === void 0 ? void 0 : rates.length, " gap-4") }, { children: rates &&
            (rates === null || rates === void 0 ? void 0 : rates.map(function (rate) {
                var _a, _b, _c;
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-8 border rounded p-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: (_a = rate === null || rate === void 0 ? void 0 : rate.service_level) === null || _a === void 0 ? void 0 : _a.name, bold: true }), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: (_b = rate === null || rate === void 0 ? void 0 : rate.service_level) === null || _b === void 0 ? void 0 : _b.description })] })), (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: "R".concat(rate === null || rate === void 0 ? void 0 : rate.rate), bold: true, size: "xlarge", center: true }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "mt-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { loading: selectedID === ((_c = rate === null || rate === void 0 ? void 0 : rate.service_level) === null || _c === void 0 ? void 0 : _c.id), label: "Select", size: "small", backgroundColor: "bg-primary", textColor: "text-white", onClick: function () { return _onSubmit(rate); } }) }))] })));
            })) })));
};
exports.default = RateViewComponent;
